import { getBookingDetailAction } from "../../../Actions/LogicActions/TicketDetail/GetBookingDetailAction";
import { syncAlreadyAddonsAction } from "../../../Actions/LogicActions/Addons/SyncAlreadyAddonsAction";
import { downloadTicketAction } from "../../../Actions/UIActions/TicketDetail/DownloadTicketAction";
import { multiTicketSlickChangeAction } from "../../../Actions/UIActions/TicketDetail/MultiTicketSlickChangeAction";
import { passengerNextPrevAction } from "../../../Actions/UIActions/TicketDetail/PassengerNextPrevAction";
import { shareTicketAction } from "../../../Actions/UIActions/TicketDetail/ShareTicketAction";
import { ticketOfferChangeAction } from "../../../Actions/UIActions/TicketDetail/TicketOfferChangeAction";
import { ticketPopupOpenCloseAction } from "../../../Actions/UIActions/TicketDetail/TicketPopupOpenCloseAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { IGetTicketAction, IPassengerChangeTicketAction, ITicketModalPopupAction } from "../../../Orchestrator/Types/Interface/EventParams/TicketAction";
import { UpcomingPastBookingContext } from "../../UpcomingPastBooking/Context/UpcomingPastBookingContext";
import { TicketDetailContext } from "../Context/TicketDetailContext";


class TicketDetailInitStep extends StepFlow {
    get stepName() { return "TicketDetailInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IGetTicketAction, void>({
                eventName: bookingTree.Ticket.Init,
                handler: async (payload) => {
                    let context = this.getCtx<TicketDetailContext>("ticketDetailContext")!;
                    context.bookingId = payload.data?.bookingId!
                    getBookingDetailAction.setParams(payload.data!)
                    await getBookingDetailAction.execute();
                    // Seed alreadyAddonsLegPassengerAtom for TicketAddons —
                    // outside checkout/manage flows nothing else populates it.
                    // forDisplayOnly: true — this sync must ignore stale
                    // change-date/manage-seating flow state left over from
                    // an aborted flow (survives SPA navigation), since this
                    // is a read-only display sync, not part of those flows.
                    syncAlreadyAddonsAction.setParams({ forDisplayOnly: true });
                    await syncAlreadyAddonsAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ITicketModalPopupAction, void>({
                eventName: bookingTree.Ticket.Popup.Close,
                handler: async (payload) => {
                    let context = this.getCtx<TicketDetailContext>("ticketDetailContext")!;
                    context.bookingId = payload.data?.bookingId!
                    ticketPopupOpenCloseAction.setParams(payload.data!);
                    await ticketPopupOpenCloseAction.execute();
                    if(ticketPopupOpenCloseAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        this.next();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ bookingDetails: IBookingResponse }, void>({
                eventName: bookingTree.Ticket.Share.Click,
                handler: async (payload) => {
                    shareTicketAction.setParams(payload.data!);
                    shareTicketAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ passengerDetails: any }, void>({
                eventName: bookingTree.Ticket.Download.Click,
                handler: async (payload) => {
                    downloadTicketAction.setParams(payload.data!);
                    downloadTicketAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IPassengerChangeTicketAction, void>({
                eventName: bookingTree.Ticket.Passenger.PrevNextClick,
                handler: async (payload) => {
                    passengerNextPrevAction.setParams(payload.data!)
                    passengerNextPrevAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ indexValue: number }, void>({
                eventName: bookingTree.Ticket.Offer.Change,
                handler: async (payload) => {
                    ticketOfferChangeAction.setParams(payload.data!)
                    ticketOfferChangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<{ legIndex: number }, void>({
                eventName: bookingTree.Ticket.MultiTicket.Change,
                handler: async (payload) => {
                    multiTicketSlickChangeAction.setParams(payload.data!)
                    await multiTicketSlickChangeAction.execute();
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        this.setCtx("ticketDetailContext", TicketDetailContext)
        console.log("Ticket Detail Initial Step Executed.....");
    }
}

export const TicketDetailInitStepDeclaration = new StepDefinition({
    stepName: "TicketDetailInit_Step",
    stepClass: TicketDetailInitStep
});